import { render, staticRenderFns } from "./modifyInfo.vue?vue&type=template&id=2159be52&scoped=true"
import script from "./modifyInfo.vue?vue&type=script&lang=js"
export * from "./modifyInfo.vue?vue&type=script&lang=js"
import style0 from "./modifyInfo.vue?vue&type=style&index=0&id=2159be52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2159be52",
  null
  
)

export default component.exports